const txt=k=>window.PHBrightText[k];
const menu=document.querySelector('.menu-toggle');
const nav=document.querySelector('#navigation');
const closeMenu=()=>{menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label',txt('t_0ed77fd2619b'));nav.classList.remove('open');};
menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')==='true';menu.setAttribute('aria-expanded',String(!open));menu.setAttribute('aria-label',open?txt('t_0ed77fd2619b'):txt('t_99904db30de4'));nav.classList.toggle('open',!open);});
nav.addEventListener('click',e=>{if(e.target.closest('a'))closeMenu();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.getAttribute('aria-expanded')==='true'){closeMenu();menu.focus();}});
const updateCurrentNavigation=()=>{
  nav.querySelectorAll('a[aria-current]').forEach(link=>link.removeAttribute('aria-current'));
  const page=document.body.dataset.current;
  const inLearningCenter=page==='learn'||page==='ira-blog'||page==='ira-article';
  const current=inLearningCenter?nav.querySelector('[data-page="learn"]'):nav.querySelector(`[data-page="${page}"]`);
  current?.setAttribute('aria-current',inLearningCenter?'location':'page');
};
updateCurrentNavigation();
window.addEventListener('hashchange',updateCurrentNavigation);

